import React from "react";
import { Col, Row, Card } from "antd";
import proposal_submission from "../images/proposal-submission.svg";
import { TryProduct } from "./TryTheProduct";

interface userProp { currentUser: any; }

const ProposalSubmission: React.FC<userProp> = ({ currentUser }) =>  {
  return (
    <Card hoverable bodyStyle={{width: '100%'}} className={currentUser ? "product-layout product-layout-logged" : "product-layout"}>
      <div >
        <Row>
        <Col>
        <div className="product-description-img">
          <div className="product-img-border">
            <img
              className="product-img"
              src={proposal_submission}
              height="100%"
              alt="scientia-image"
            />
          </div>
        </div>
        </Col>
        </Row>
        <p className="eyebrow-text">Propose your next research ideas</p>
        <h2 className="h2 h2-proposal-submission">Proposal Management</h2>
        <p className="p" style={{width: '100%'}}>
          Online platform for individuals and organizations to submit, edit, and track status of proposals and user projects.
        </p>
       
          <p className="product-button">Manage Proposals
          <TryProduct />
          </p>
      </div>
  </Card>
  );
};

export default ProposalSubmission;
